/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Setpointtemperatureact2Inputs */



/**
* | output |
* | --- |
* | "Current setpoint temperature" |
*
* @param {Br_History_Key_Setpointtemperatureact2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_setpointtemperatureact2 = /** @type {((inputs?: Br_History_Key_Setpointtemperatureact2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Setpointtemperatureact2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Current setpoint temperature")
	return /** @type {LocalizedString} */ ("Température de consigne actuelle")
});
export { br_history_key_setpointtemperatureact2 as "br_history_key_setpointTemperatureAct" }